import React from "react";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import * as XLSX from "xlsx";

const hasValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  return true;
};

const filterColumnsWithValues = (rows = []) => {
  if (!Array.isArray(rows) || rows.length === 0) return [];

  const keys = Object.keys(rows[0] || {});
  const keysWithValues = keys.filter((key) => rows.some((row) => hasValue(row?.[key])));

  return rows.map((row) => {
    const filteredRow = {};
    keysWithValues.forEach((key) => {
      filteredRow[key] = row?.[key];
    });
    return filteredRow;
  });
};

const ExportExcelWidget = ({ excelData, fileName, onlyColumnsWithValues = false }) => {
  const exportToExcel = (fileName) => {
    const dataToExport = onlyColumnsWithValues
      ? filterColumnsWithValues(excelData)
      : excelData;

    if (!dataToExport || dataToExport.length === 0) return;

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "data");
    XLSX.writeFile(wb, fileName + ".xlsx");
  };
  return (
    <>
      <CommonButton
        onClick={() => {
          if (excelData.length == 0) return;
          exportToExcel(fileName);
        }}
      >
        Excel Export
      </CommonButton>
    </>
  );
};
export default ExportExcelWidget;
